<template>
  <Layout>
    <b-overlay :show="isLoading" rounded="sm">

      <div class="card">
        <div class="card-body">
          <PageHeader :title="title" :items="items" />
          <div class="form-row">
            <div class="form-group col-md-12">
              <label>Expediente</label>
              <v-select
                  :options="expedientes"
                  label="obra_expediente"
                  :reduce="desc=>desc.expediente_id"
                  v-model="expediente_id"
              />
            </div>
          </div>
          <div class="row">
            <ag-grid-vue
                style="width: 100%; height: 400px"
                class="ag-theme-balham"
                :columnDefs="columnDefs"
                :rowData="rowData"
                :gridOptions="gridOptions"
                @grid-ready="onGridReady"
            >
            </ag-grid-vue>
          </div>
        </div>
      </div>
    </b-overlay>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Importar",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Importar",
      items: [
        {
          text: "Gastos",
        }
      ],
      isLoading: false,
      server: process.env.VUE_APP_BACKEND,
      lista:[],
      reportes:[],
      fecha:null,
      expediente_id:null,
      gridApi: null,
      columnApi: null,
      columnDefs:[],
      rowData:[],
      gridOptions: {
        //floatingFiltersHeight:50,
        defaultColDef: {
          sortable: true,
          resizable: true,
          floatingFilter:true
        },

      },
      total:0,
      expedientes:[],
      custom:[
        { key: 'thisWeek', label: 'Esta semana', value: 'isoWeek' },
        { key: 'lastWeek', label: 'Ultima semana', value: '-isoWeek' },
        { key: 'last7Days', label: 'Ultimos 7 dias', value: 7 },
        { key: 'last30Days', label: 'Ultimos 30 dias', value: 30 },
        { key: 'thisMonth', label: 'Este mes', value: 'month' },
        { key: 'lastMonth', label: 'Ultimo mes', value: '-month' },
        { key: 'thisYear', label: 'Este año', value: 'year' },
        { key: 'lastYear', label: 'Ultimo año', value: '-year' }
      ]
    };
  },
  beforeMount() {

    this.columnDefs= [

    ];
    this.rowData= [

    ];

  },
  methods: {
    cambiarMes(date){
      this.fecha_mes.mes=date.monthIndex;
      this.fecha_mes.anio=date.year;
    },
    onBtnExport() {
      this.gridApi.exportDataAsCsv();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    }
  },
  mounted() {
    this.$cargarExpedientes( (res)=>{
      this.expedientes=res.data
    },()=>{});

  }
}
</script>

<style>
.fixtable {
  color: #000000 !important;
}
</style>
